import React from 'react'

require('./news.scss')
require('./mobile_news.scss')
import { Get, wrapResponse } from './../../../requst'
export default class News extends React.Component {
    static async getInitialProps(ctx) {
        const data = await wrapResponse(Get({ url: 'base/news' }))
        return { data }
    }

    constructor(props, context) {
        super(props, context);
        this.renderAppList = this.renderAppList.bind(this);
        this.renderWechatList = this.renderWechatList.bind(this);
        this.renderSaaSList = this.renderSaaSList.bind(this);
        this.state = {

        }

    }
    componentDidMount() {
        !function (e) {
            function t(a) { if (i[a]) return i[a].exports; var n = i[a] = { exports: {}, id: a, loaded: !1 }; return e[a].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports } var i = {};
            return t.m = e, t.c = i, t.p = "", t(0)
        }([function (e, t) {
            "use strict"; Object.defineProperty(t, "__esModule", { value: !0 });
            var i = window;
            t["default"] = i.flex = function (normal, e, t) {
                var a = e || 100, n = t || 1, r = i.document, o = navigator.userAgent, d = o.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i), l = o.match(/U3\/((\d+|\.){5,})/i), c = l && parseInt(l[1].split(".").join(""), 10) >= 80, p = navigator.appVersion.match(/(iphone|ipad|ipod)/gi), s = i.devicePixelRatio || 1;
                p || d && d[1] > 534 || c || (s = 1); var u = normal ? 1 : 1 / s, m = r.querySelector('meta[name="viewport"]'); m || (m = r.createElement("meta"), m.setAttribute("name", "viewport"), r.head.appendChild(m)), m.setAttribute("content", "width=device-width,user-scalable=no,initial-scale=" + u + ",maximum-scale=" + u + ",minimum-scale=" + u), r.documentElement.style.fontSize = normal ? "50px" : a / 2 * s * n + "px"
            }, e.exports = t["default"]
        }]); flex(false, 100, 1);

        this.setState({ offsetWidth: document.body.offsetWidth })
    }
    // componentDidMount() {
    //     this.Get({url:'base/news'}).then((res)=>{
    //         console.log(res)
    //         this.setState({data:res.data.data})
    //     })
    // }
    renderAppList() {
        if (this.props.data.appModule.appNews.length > 0) {
            return this.props.data.appModule.appNews.map((item, index) => (
                <a href={`/details/${item.id}?id=${item.id}&cate_id=${this.props.data.appModule.appCate.title}`} key={index} >·<span className="SubHead">{item.title.length > 13 ? `${item.title.substring(0, 13)}...` : item.title}</span> <span className="Timer">{item.created_at.substring(0, 11)}</span></a>
            ))
        } else {
            return null
        }

    }
    renderWechatList() {
        if (this.props.data.weiModule.weiNews.length > 0) {
            return this.props.data.weiModule.weiNews.map((item, index) => (
                <a href={`/details/${item.id}?id=${item.id}&cate_id=${this.props.data.weiModule.weiCate.title}`} key={index}>·<span className="SubHead">{item.title.length > 13 ? `${item.title.substring(0, 13)}...` : item.title}</span> <span className="Timer">{item.created_at.substring(0, 11)}</span></a>
            ))
        } else {
            return null
        }

    }
    renderSaaSList() {
        if (this.props.data.SaasModule.SaasNews.length > 0) {
            return this.props.data.SaasModule.SaasNews.map((item, index) => (
                <li key={index} href={`/details/${item.id}?id=${item.id}&cate_id=${this.props.data.SaasModule.SaasCate.title}`}>·<span className="SubHead">{item.title.length > 13 ? `${item.title.substring(0, 13)}...` : item.title}</span> <span className="Timer">{item.created_at.substring(0, 11)}</span></li>
            ))
        } else {
            return null
        }
    }
    render() {
        // console.log(document.body.offsetWidth)

        if (this.state.offsetWidth >= 1200) {
            return (
                <div className="newsContainer">
                    <div className="Title">
                        <p>新闻资讯</p>
                        <p>News And Information</p>
                        <img src={require('../../../assets/common/images/biaotizhuangshi.png')} alt="" />
                    </div>
                    {this.props.data ? <ul className="NewsList">
                        <li className="NewsListModule">
                            <div className="ListImage">
                                <img src={this.props.data ? this.props.data.appModule.appNews[0].thumb : null} alt="" />
                                <div className="ListHead">
                                    <p className="P_Two">{this.props.data ? this.props.data.appModule.appNews[0].created_at.substring(8, 11) : null}</p>
                                    <p className="P_One">{this.props.data ? this.props.data.appModule.appNews[0].created_at.substring(0, 7) : null}</p>
                                </div>
                            </div>
                            <ul className="TextList">
                                <a href="/newscenter?key=1" className="TextHead TextCommon FristIcon" style={{ cursor: 'pointer' }}>APP开发资讯></a>
                                {this.props.data ? this.renderAppList() : null}

                            </ul>
                        </li>
                        <li className="NewsListModule">
                            <div className="ListImage">
                                <img src={this.props.data ? this.props.data.weiModule.weiNews[0].thumb : null} alt="" />
                                <div className="ListHead">
                                    <p className="P_Two">{this.props.data ? this.props.data.weiModule.weiNews[0].created_at.substring(8, 11) : null}</p>
                                    <p className="P_One">{this.props.data ? this.props.data.weiModule.weiNews[0].created_at.substring(0, 7) : null}</p>
                                </div>
                            </div>
                            <ul className="TextList">
                                <a href="/newscenter?key=2" className="TextHead TextCommon SecondIcon" style={{ cursor: 'pointer' }}>微信开发资讯></a>
                                {this.props.data ? this.renderWechatList() : null}
                            </ul>
                        </li>
                        <li className="NewsListModule">
                            <div className="ListImage">
                                <img src={this.props.data ? this.props.data.SaasModule.SaasNews[0].thumb : null} alt="" />
                                <div className="ListHead">
                                    <p className="P_Two">{this.props.data ? this.props.data.SaasModule.SaasNews[0].created_at.substring(8, 11) : null}</p>
                                    <p className="P_One">{this.props.data ? this.props.data.SaasModule.SaasNews[0].created_at.substring(0, 7) : null}</p>
                                </div>
                            </div>
                            <ul className="TextList">
                                <a href="/newscenter?key=3" className="TextHead TextCommon ThirdIcon" style={{ cursor: 'pointer' }}>电商SaaS资讯></a>
                                {this.props.data ? this.renderSaaSList() : null}
                            </ul>
                        </li>
                    </ul> : null}
                </div>
            )
        } else {
            return (
                <div className="Mobile_News">
                    <p className="Mobile_Title">新闻咨询</p>
                    <p className="Mobile_SubTitle">NEWS AND INFORMATION</p>
                    <img src={require('../../../assets/common/images/biaoti-zhuanshi@3x.png')} alt="" />
                    <div className="Mobile_NewsContent">
                        <img className="fl" src={require('../../../assets/common/images/shiyan.jpg')} alt="" />
                        <div className="Sign">
                            <p className="P_Big">02</p>
                            <p className="P_Small">19-01</p>
                        </div>
                        <p className="P_Head fr">我想做个app需要多长时间，我想做个app需要多长时间，我想做？</p>
                        <p className="P_Cont fr">我想做个app 多长时间，我想做个app 多长时间，我想做个app 多长时间···</p>
                    </div>
                    <button></button>
                </div>
            )
        }

    }
}